import { render } from "./EditProductPage.vue?vue&type=template&id=27359cc7&scoped=true"
import script from "./EditProductPage.vue?vue&type=script&lang=js"
export * from "./EditProductPage.vue?vue&type=script&lang=js"

import "./EditProductPage.vue?vue&type=style&index=0&id=27359cc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27359cc7"]])

export default __exports__